import "./CaseStudyBudgetHotelKenyaRevenueOptimization.module.css";
import Header from "@/reusable_sections/Header";
import Casestudyhero from "./sections/Casestudyhero";
import MarketChallengesStats from "./sections/MarketChallengesStats";
import StrategicImplementationPlan from "./sections/StrategicImplementationPlan";
import Performance from "./sections/Performance";
import RevenueFaq from "./sections/RevenueFaq";
import Footer from "@/reusable_sections/Footer";
export default function CaseStudyBudgetHotelKenyaRevenueOptimizationPage() {
  return <div>
      <Header />
      <Casestudyhero />
      <MarketChallengesStats />
      <StrategicImplementationPlan />
      <Performance />
      <RevenueFaq />
      <Footer />
    </div>;
}